<template>
  <section-meta
    :count="comments.length"
    label="Comments"
    intro="Stay in the loop and maybe even engadge"
  >
    <div class="">
      <item-comment
        class="bg-white"
        v-for="c in comments"
        :comment="c"
        :key="c.id"
      />
    </div>
  </section-meta>
</template>

<script>
import SectionMeta from '@/components/SectionMeta'
import ItemComment from '@/components/items/ItemComment'

export default {
  name: 'CardSectionComments',
  props: {
    comments: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ItemComment,
    SectionMeta
  },
  watch: {
    comments(val) {
      if (val) this.sendScroll()
    }
  },
  mounted() {
    this.sendScroll()
  },
  methods: {
    async sendScroll() {
      await this.$nextTick()
      this.$emit('section-scroll-end')
    }
  }
}
</script>
